__turbopack_context__.v({
  "Active": "premium-module__zNuela__Active",
  "ActiveTab": "premium-module__zNuela__ActiveTab",
  "AllContent": "premium-module__zNuela__AllContent",
  "Colradd": "premium-module__zNuela__Colradd",
  "FaqSec": "premium-module__zNuela__FaqSec",
  "Plantitle": "premium-module__zNuela__Plantitle",
  "PlantitleNew": "premium-module__zNuela__PlantitleNew",
  "PreTitle": "premium-module__zNuela__PreTitle",
  "Price": "premium-module__zNuela__Price",
  "SecondTab": "premium-module__zNuela__SecondTab",
  "UnlockPaid": "premium-module__zNuela__UnlockPaid",
  "Wrapper": "premium-module__zNuela__Wrapper",
  "accordion": "premium-module__zNuela__accordion",
  "accordion--radio": "premium-module__zNuela__accordion--radio",
  "accordionSec": "premium-module__zNuela__accordionSec",
  "bounce": "premium-module__zNuela__bounce",
  "btndisabled": "premium-module__zNuela__btndisabled",
  "cardContent": "premium-module__zNuela__cardContent",
  "cardContentWrapper": "premium-module__zNuela__cardContentWrapper",
  "cardDetail": "premium-module__zNuela__cardDetail",
  "cardStandard": "premium-module__zNuela__cardStandard",
  "cardStandardPrice": "premium-module__zNuela__cardStandardPrice",
  "cardWidth": "premium-module__zNuela__cardWidth",
  "cardWidthTab": "premium-module__zNuela__cardWidthTab",
  "carddetailsplan": "premium-module__zNuela__carddetailsplan",
  "cardsetWidth": "premium-module__zNuela__cardsetWidth",
  "checkIcon": "premium-module__zNuela__checkIcon",
  "checkmark": "premium-module__zNuela__checkmark",
  "clear": "premium-module__zNuela__clear",
  "commonBtnIcon": "premium-module__zNuela__commonBtnIcon",
  "crossPrice": "premium-module__zNuela__crossPrice",
  "currentInfo": "premium-module__zNuela__currentInfo",
  "currentPlanTitle": "premium-module__zNuela__currentPlanTitle",
  "customCheckbox": "premium-module__zNuela__customCheckbox",
  "days": "premium-module__zNuela__days",
  "disabled": "premium-module__zNuela__disabled",
  "disabledTab": "premium-module__zNuela__disabledTab",
  "features": "premium-module__zNuela__features",
  "gridColAuto": "premium-module__zNuela__gridColAuto",
  "gridWrapper": "premium-module__zNuela__gridWrapper",
  "innercard": "premium-module__zNuela__innercard",
  "lableArrow_icon": "premium-module__zNuela__lableArrow_icon",
  "months": "premium-module__zNuela__months",
  "offer": "premium-module__zNuela__offer",
  "offprice": "premium-module__zNuela__offprice",
  "paymentBtn": "premium-module__zNuela__paymentBtn",
  "paymentByApp": "premium-module__zNuela__paymentByApp",
  "paymentcard": "premium-module__zNuela__paymentcard",
  "premiumBtn": "premium-module__zNuela__premiumBtn",
  "premiumSec": "premium-module__zNuela__premiumSec",
  "priceLinecross": "premium-module__zNuela__priceLinecross",
  "priceOriginal": "premium-module__zNuela__priceOriginal",
  "qualityNum": "premium-module__zNuela__qualityNum",
  "radioCard": "premium-module__zNuela__radioCard",
  "remainTime": "premium-module__zNuela__remainTime",
  "tab": "premium-module__zNuela__tab",
  "tab__close": "premium-module__zNuela__tab__close",
  "tab__content": "premium-module__zNuela__tab__content",
  "tab__label": "premium-module__zNuela__tab__label",
  "topTextWrapper": "premium-module__zNuela__topTextWrapper",
});
